import { render } from "./ReadingArticle.vue?vue&type=template&id=23247402&scoped=true"
import script from "./ReadingArticle.vue?vue&type=script&lang=js"
export * from "./ReadingArticle.vue?vue&type=script&lang=js"

import "./ReadingArticle.vue?vue&type=style&index=0&id=23247402&scoped=true&lang=less"
import "./ReadingArticle.vue?vue&type=style&index=1&id=23247402&scoped=true&lang=css"
import "./ReadingArticle.vue?vue&type=style&index=2&id=23247402&lang=css"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23247402"]])

export default __exports__